import { render, staticRenderFns } from "./PromoTopBar.vue?vue&type=template&id=c447dc8a&scoped=true&"
import script from "./PromoTopBar.vue?vue&type=script&lang=js&"
export * from "./PromoTopBar.vue?vue&type=script&lang=js&"
import style0 from "./PromoTopBar.vue?vue&type=style&index=0&id=c447dc8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c447dc8a",
  null
  
)

export default component.exports